<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true 
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        })
      }
    },

  }

</script>

<style>
@import url("./assets/reset");
@import url("./assets/styleiconfont/styleiconfont.css");

#app {
  height: inherit;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue